module.exports = __webpack_public_path__ + "img/card_logo.4ecb32d6.png";